import { render } from "./StandardInput.vue?vue&type=template&id=7405eefe"
import script from "./StandardInput.vue?vue&type=script&lang=js"
export * from "./StandardInput.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__